export const environment = {
  production: false,
  apiUrl: 'https://dev.api.talenthub.seiza-ti.com/api',
  firebaseConfig: {
    apiKey: 'AIzaSyD82Zimb2Lr1RJvGu3GxoShQVAflcHwERY',
    authDomain: 'sza-preprod.firebaseapp.com',
    projectId: 'sza-preprod',
    storageBucket: 'sza-preprod.appspot.com', // Consultar sobre si se reemplazaria por un bucket en GCP
    messagingSenderId: '359616739836',
    appId: '1:359616739836:web:ab7e125d382b654e221a79',
    measurementId: 'G-Q3ZK3FC99K',
  },
  tenantId: 'dev-talenthub-2fn4x',
};
